/* eslint-disable react/no-unknown-property */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useEffect, useMemo, useState } from 'react';
import { Row, Col, Divider, message } from 'antd';
import { formatError, formatString } from 'utils';
import { Card } from 'components/gyramais';
import { Progress, Slider } from 'components/sdk';
import useWindowDimensions from 'utils/hooks/useWindowDimensions';

import './styles.less';
import { useMutation } from '@apollo/client';
import { CALCULATE_LOAN_VOLTZ } from './graphql';

let debounce;

/**
 *
 * @param {{
 *  loan: any
 *  onChangeValues?: void
 * }} props
 * @returns {React.FC}
 */
const PreApprovedVoltzCard = ({ loan, onChangeValues }) => {
  const { width } = useWindowDimensions();

  const [contratoVoltz, setContratoVoltz] = useState();
  const [installments, setInstallments] = useState(0);
  const [amount, setAmount] = useState(0);
  const [paymentDay, setPaymentDay] = useState(0);
  const [installmentAmount, setInstallmentAmount] = useState(0);

  const paymentDaysOptions = useMemo(() => [1, 5, 10, 15, 20]);

  const [calculateLoanVoltz] = useMutation(CALCULATE_LOAN_VOLTZ, {
    onCompleted: ({ calculateLoanVoltz: { installmentAmount } = {} }) => {
      setInstallmentAmount(installmentAmount);
    },
    onError: (e) => message.error(formatError(e)),
  });

  const handleCalculate = ({ valor, prazo }) => {
    setInstallmentAmount(undefined);

    clearTimeout(debounce);

    debounce = setTimeout(() => {
      calculateLoanVoltz({
        variables: {
          loanId: loan.id,
          valor,
          prazo,
        },
      });
    }, 1000);
  };

  useEffect(
    () =>
      onChangeValues?.({
        amount,
        installments,
        installmentAmount,
        paymentDay: paymentDaysOptions[paymentDay],
      }),
    [amount, installments, installmentAmount, paymentDay],
  );

  useEffect(() => {
    if (!loan?.id) {
      return;
    }

    const contract = loan.additionalInfo?.contratoVoltz;
    if (contract) {
      const parsed = JSON.parse(loan.additionalInfo.contratoVoltz);
      setAmount(parsed.valorDisponivel);
      setInstallments(parsed.prazo);
      setContratoVoltz(parsed);
    }

    const date = loan.firstPaymentDate && new Date(loan.firstPaymentDate);
    if (date) {
      date.setHours(date.getHours() + 3);

      const paymentDayIndex = paymentDaysOptions.indexOf(date.getDate());
      setPaymentDay(paymentDayIndex);
    }

    setInstallmentAmount(loan.installmentAmount);
  }, [loan?.id]);

  return (
    <Card className="pre-approved-card-voltz">
      <Row gutter={[56, 16]} align="middle">
        <Col xs={24} sm={24} md={11}>
          <div align="middle">
            <h4>
              <b>Sua proposta pré-aprovada!</b>
            </h4>
            <br />
          </div>

          <div className="pre-approved-progress-container">
            <Progress
              className="pre-approved-progress"
              type="circle"
              percent={100}
              progressColor="success"
              strokeWidth={9}
            />

            {/* eslint-disable-next-line react/no-unknown-property */}
            <div className="pre-approved-progress-content" align="middle">
              <p className="no-margin-bottom pre-approved-progress-label secondary-text">
                Valor
                <br />
                disponível
              </p>

              <h5>
                <strong>
                  {formatString(contratoVoltz?.valorDisponivel, 'currency')?.split('.')[0]} mil
                </strong>
              </h5>
            </div>
          </div>

          <div align="middle">
            <p className="no-margin-bottom">
              <strong>Total pré-aprovado</strong>
            </p>

            <h3>
              <strong className="success-text">
                {formatString(contratoVoltz?.valorDisponivel || 10000, 'currency')}
              </strong>
            </h3>
          </div>
        </Col>

        <Col xs={24} sm={24} md={2} align="middle">
          <Divider
            type={width > 768 && 'vertical'}
            className={width > 768 ? 'pre-approved-vertical-divider' : ''}
          />
        </Col>

        <Col xs={24} sm={24} md={11}>
          <Row gutter={[0, 30]}>
            <Col span={24}>
              <h5>
                <b>Prazo</b>
              </h5>

              <Slider
                tooltipVisible={false}
                min={6}
                max={contratoVoltz?.prazo || 36}
                step={1}
                showValues
                value={installments}
                valuesFormatter={(value) => `${value} meses`}
                onChange={(value) => {
                  setInstallments(value);
                  handleCalculate({ valor: amount, prazo: value });
                }}
              />
            </Col>

            <Col span={24}>
              <h5>
                <b>Valor solicitado</b>
              </h5>

              <Slider
                tooltipVisible={false}
                min={10000}
                max={contratoVoltz?.valorDisponivel || 10000}
                value={amount}
                onChange={(value) => {
                  setAmount(value);
                  handleCalculate({ valor: value, prazo: installments });
                }}
                step={1000}
                showValues
                valuesFormatter={(e) => {
                  if (width <= 768) {
                    return `${formatString(e, 'currency')?.split('.')[0]} mil`;
                  }
                  return formatString(e, 'currency');
                }}
                input={{ type: 'currency' }}
              />
            </Col>

            <Col span={24}>
              <h5>
                <b>Dia de vencimento</b>
              </h5>

              <Slider
                tooltipVisible={false}
                min={0}
                max={paymentDaysOptions.length - 1}
                marks={paymentDaysOptions}
                value={paymentDay}
                onChange={setPaymentDay}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export default PreApprovedVoltzCard;
